module.exports = __webpack_public_path__ + "static/black-aa-women-desktop.42303681.webp";